import IAddOn from "../interfaces/IAddOn"
import { get, transformRequestData } from "./utils/requests"

const forCamp = (
  campId: string,
  options?: {
    siteIds?: string[],
    campingStyleIds?: string[],
  }
): Promise<{ products: IAddOn[] }> =>
  get(`/api/camps/${campId}/products`, transformRequestData(options || {}))

const Products = {
  forCamp,
}

export default Products
